import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

//Documentos

  const DetDocum = ({elemento, tipoCargue}) => {
    if(tipoCargue==="Upd"){
      return(
        <tr className=''>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.consecutivo}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoLub}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadTotal?elemento.cantidadTotal:0}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidad?elemento.cantidad:0}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.puntosLub}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minutos}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.modoTarea?elemento.modoTarea:''}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.requiereSISO?elemento.requiereSISO:''}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuenciaPre}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProx}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codProcedimiento}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codInfoTarea}</td>
          <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.activo}</td>
        </tr>
      )
    };
  }

const ListaDocum = ({list, tipoCargue}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetDocum elemento={elemento} key={i} tipoCargue={tipoCargue}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class CargProg2 extends React.Component {
  state={listDocum: [], checked: true, permiteUpdate: true, confirmaAct: false, open: false, errors: [],
    argsQuery: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, descrPlanta: 1,
        descrSeccion: '$secciones.descrSeccion',
        descrEquipo: '$secciones.equipos.descrEquipo',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo'}}`,

    argsQuery1: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, descrPlanta: 1,
        descrSeccion: '$secciones.descrSeccion',
        descrEquipo: '$secciones.equipos.descrEquipo',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
        descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea'}}`
  }

  crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

    //Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    //ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }

    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = async (ev) => {
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        // let response = await this.props.fecha({
        //   variables: {}
        // });
        // const {fechaHoraHoy} = response.data.fecha

        let archcsv = ""
// console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        let tipoCargue = this.props.tipoCargue 
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()

          let lines = archivo.split(/\n/)
          let numDoc = 0, linea = 0, listDocum = []
          // console.log(lines)
          if(tipoCargue==="Upd"){ 
            lines.forEach(line => {
              if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
                linea += 1
                //crear array de campos para cada linea
                let campos = line.split(";")
                let consecutivo = campos[0]?campos[0]:0
                let descrEmpresa = campos[1].replace(/^\s+|\s+$/g, '')
                let descrPlanta = campos[2].replace(/^\s+|\s+$/g, '')
                let descrSeccion = campos[3].replace(/^\s+|\s+$/g, '')
                let descrEquipo = campos[4].replace(/^\s+|\s+$/g, '')
                let descrComponente = campos[6].replace(/^\s+|\s+$/g, '')
                let descrMecanismo = campos[7].replace(/^\s+|\s+$/g, '')
                let descrAplicacion = campos[8].replace(/^\s+|\s+$/g, '')
                let tipoLub = campos[9].replace(/^\s+|\s+$/g, '')
                let descrLubricante = campos[10].replace(/^\s+|\s+$/g, '')
                let cantidad=0
                if(campos[11]!==null && campos[11]!==''){
                  cantidad=campos[11].replace(/\./g,'')
                  cantidad = cantidad.replace(/\,/g,'.');
                  cantidad = parseFloat(cantidad)              
                  if(!cantidad){
                    cantidad=0
                  }
                }
                let abrevUnidad = campos[12].replace(/^\s+|\s+$/g, '')
                let minutos = campos[13]
                let descrMetodo = campos[14].replace(/^\s+|\s+$/g, '')
                let descrTarea = campos[15].replace(/^\s+|\s+$/g, '')
                let descrMetodoNuevo = campos[16].replace(/^\s+|\s+$/g, '')
                let descrTareaNuevo = campos[17].replace(/^\s+|\s+$/g, '')
                let modoTarea = campos[18].replace(/^\s+|\s+$/g, '')
                let requiereSISO = campos[19].replace(/^\s+|\s+$/g, '')
                let puntosLub=campos[20]?parseInt(campos[20]):0
                let descrFrecuencia = campos[21].replace(/^\s+|\s+$/g, '')
                let descrFrecuenciaPre = campos[22].replace(/^\s+|\s+$/g, '')
                let fechaProx = ''
                // if(tipoCargue = 'add'){
                let campoMes = ''
                let campoDia= ''
                if(campos[24]!==null && campos[24]!=='' && campos[25]!==null && campos[25]!=='' && campos[26]!==null && campos[26]!==''){
                  let mes = parseInt(campos[25], 10)
                  if(mes < 10){ 
                    campoMes='0' + mes
                  }else{
                    campoMes = mes
                  }
                  let dia = parseInt(campos[26], 10)
                  if(dia < 10){ 
                    campoDia='0' + dia
                  }else{
                    campoDia = dia
                  }
                  fechaProx = campos[24] + '-' + campoMes + '-' + campoDia
                }
                let acumProx = campos[27]?parseInt(campos[27]):0
                let codProcedimiento = campos[28]?campos[28].replace(/^\s+|\s+$/g, ''):''
                let codInfoTarea = campos[29]?campos[29].replace(/^\s+|\s+$/g, ''):''
                let activo = campos[30]?campos[30].replace(/^\s+|\s+$/g, ''):'S'
  //Separador de decimales => .

                listDocum.push({consecutivo, descrEmpresa, descrPlanta, descrSeccion, 
                  descrEquipo, descrComponente, descrMecanismo, descrAplicacion, 
                  tipoLub, descrLubricante, cantidad, abrevUnidad, minutos, descrMetodo, descrTarea, descrMetodoNuevo, descrTareaNuevo, 
                  modoTarea, requiereSISO, puntosLub, descrFrecuencia, descrFrecuenciaPre, fechaProx, acumProx, codProcedimiento, codInfoTarea, activo})
              } 
              numDoc += 1
            })
            listDocum = _.orderBy(listDocum, ['consecutivo'], ['asc'])
            updState(listDocum)
          };
        }  
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
        this.setState({checked: checkTieneEncab})
      }else{
        this.setState({listDocum: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listDocum)=>{
    if(this.props.tipoCargue==="Upd"){
      document.body.style.cursor = 'wait'

      let allFrecuencia = this.props.allFrecuencia.allFrecuencia
      let allProcEjec = this.props.allProcEjec.allProcEjec
      let allInfoTarea = this.props.allInfoTarea.allInfoTarea
      let mecanismos = []
      let argsBuscarMec = {tipoqry: `[${this.state.argsQuery}]`}
      let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarMec)
      mecanismos = await data.allPlantaRtes
      let errors = []
      listDocum.forEach(async (elemento, i) => {
        console.log(i)
        let argsBuscarPl = {}
        let regExiste = []
        let argsBuscar = ""
        let descrEmpresa = elemento.descrEmpresa, descrPlanta = elemento.descrPlanta
        let descrSeccion = elemento.descrSeccion, descrEquipo = elemento.descrEquipo
        let descrComponente = elemento.descrComponente, descrMecanismo = elemento.descrMecanismo

        if(!descrEmpresa){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Empresa NO REPORTADA`});
        }
        if(!descrPlanta){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Planta NO REPORTADA`});
        }
        if(!descrSeccion){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Sección NO REPORTADA`});
        }
        if(!descrEquipo){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Equipo NO REPORTADO`});
        }
        if(!descrComponente){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Componente NO REPORTADO`});
        }
        if(!descrMecanismo){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Mecanismo NO REPORTADO`});
        }


// console.time(1)
        let indexMec = mecanismos.findIndex( mecanismo => mecanismo.descrEmpresa===descrEmpresa && mecanismo.descrPlanta===descrPlanta && mecanismo.descrSeccion===descrSeccion && mecanismo.descrEquipo===descrEquipo && mecanismo.descrComponente===descrComponente && mecanismo.descrMecanismo===descrMecanismo)
        if(indexMec===-1){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} MECANISMO NO EXISTE: ${descrPlanta} ${descrSeccion} ${descrEquipo} ${descrComponente} ${descrMecanismo}`});
        }
// console.timeEnd(1)
        let indexFre = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===elemento.descrFrecuencia )
        if(indexFre===-1){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} => La frecuencia ${elemento.descrFrecuencia} no ha sido creada`});
        }
        if(listDocum[i].descrFrecuenciaPre){
          let indexFreP = allFrecuencia.findIndex( frecuencia => frecuencia.descrFrecuencia===elemento.descrFrecuenciaPre )
          if(indexFreP===-1){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} => La frecuencia predictiva ${elemento.descrFrecuenciaPre} no ha sido creada`});
          }        
        }
        if (elemento.codProcedimiento!==null && elemento.codProcedimiento!=='' && elemento.codProcedimiento!==0){
          let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento==elemento.codProcedimiento )
          if(indexProc===-1){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} => El procedimiento ${elemento.codProcedimiento} no ha sido creado`});
          }   
        }
        if (elemento.codInfoTarea!==null && elemento.codInfoTarea!=='' && elemento.codInfoTarea!==0){
          let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea==elemento.codInfoTarea )
          if(indexInfo===-1){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} => El código de advertencia ${elemento.codInfoTarea} no ha sido creado`});
          }   
        }
        if(listDocum[i].modoTarea==='I' || listDocum[i].modoTarea==='O'){
        }else{
          errors.push({path: "Cargue", message: `Línea: ${i + 1} => El modo de ejecución de tarea solo puede ser O o I`});
        }
        if(listDocum[i].requiereSISO==='Si' || listDocum[i].requiereSISO==='No'){
        }else{
          errors.push({path: "Cargue", message: `Línea: ${i + 1} => El campo Requiere SISO solo puede ser Si o No`});
        }
      })
      document.body.style.cursor = 'default'

      this.setState({errors})
      if(errors.length===0){

  //PROCESO ACTUALIZAR PROGRAMACION
        document.body.style.cursor = 'wait'

        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        let argsPl = {}, creaColecc = [], addColeccProg = [], argsProg = {}

        for(let i=0; i<listDocum.length; i++){
          let descrEmpresa = listDocum[i].descrEmpresa, descrPlanta = listDocum[i].descrPlanta
          let descrSeccion = listDocum[i].descrSeccion, descrEquipo = listDocum[i].descrEquipo
          let descrComponente = listDocum[i].descrComponente, descrMecanismo = listDocum[i].descrMecanismo
          let descrMetodo = listDocum[i].descrMetodo
          let descrTarea = listDocum[i].descrTarea
          let descrMetodoNuevo = listDocum[i].descrMetodoNuevo
          let descrTareaNuevo = listDocum[i].descrTareaNuevo
          let modoTarea = listDocum[i].modoTarea?listDocum[i].modoTarea:''
          let requiereSISO = listDocum[i].requiereSISO?listDocum[i].requiereSISO:''
          let puntosLub = listDocum[i].puntosLub
          let consecutivo = listDocum[i].consecutivo?listDocum[i].consecutivo:0
          let cantidad = listDocum[i].cantidad?listDocum[i].cantidad:0
          let minutos = listDocum[i].minutos?listDocum[i].minutos:0
          let descrFrecuencia = listDocum[i].descrFrecuencia
          let descrFrecuenciaPre = listDocum[i].descrFrecuenciaPre?listDocum[i].descrFrecuenciaPre:''
          let fechaProx = listDocum[i].fechaProx?listDocum[i].fechaProx:''
          let acumProx = listDocum[i].acumProx?parseInt(listDocum[i].acumProx):0
          let codProcedimiento = listDocum[i].codProcedimiento?listDocum[i].codProcedimiento:''
          let codInfoTarea = listDocum[i].codInfoTarea?listDocum[i].codInfoTarea:''
          let activo = listDocum[i].activo?listDocum[i].activo:'S'

          let indexProc = allProcEjec.findIndex( procejec => procejec.codProcedimiento===codProcedimiento.replace(/(\r\n|\n|\r)/gm,"") )
          if(indexProc===-1){
            argsProg['nombreArchivo'] = ''
          }else{
            argsProg['nombreArchivo'] = allProcEjec[indexProc].nombreArchivo
          }  
          let indexInfo = allInfoTarea.findIndex( infotarea => infotarea.codInfoTarea===codInfoTarea.replace(/(\r\n|\n|\r)/gm,"") )
          if(indexInfo===-1){
            argsProg['nombreArchivoInfo'] = ''
          }else{
            argsProg['nombreArchivoInfo'] = allInfoTarea[indexInfo].nombreArchivoInfo
          }              
          argsProg['descrMetodo'] = descrMetodoNuevo
          argsProg['descrTarea'] = descrTareaNuevo  
          argsProg['modoTarea'] = modoTarea       
          argsProg['requiereSISO'] = requiereSISO       
          argsProg['consecutivo'] = consecutivo
          argsProg['cantidad'] = cantidad
          argsProg['minutos'] = minutos
          argsProg['puntosLub'] = puntosLub
          argsProg['descrFrecuencia'] = descrFrecuencia
          argsProg['descrFrecuenciaPre'] = descrFrecuenciaPre
          argsProg['fechaProx'] = fechaProx
          argsProg['acumProx'] = parseInt(acumProx)
          argsProg['codProcedimiento'] = codProcedimiento
          argsProg['codInfoTarea'] = codInfoTarea
          argsProg['activo'] = activo

          addColeccProg.push(argsProg)
          argsProg = {}

          argsPl['descrMecanismo'] = descrMecanismo
          argsPl['descrComponente'] = descrComponente
          argsPl['descrEquipo'] = descrEquipo
          argsPl['descrSeccion'] = descrSeccion
          argsPl['descrEmpresa'] = descrEmpresa
          argsPl['descrPlanta'] = descrPlanta
          argsPl['descrMetodoAnt'] = descrMetodo
          argsPl['descrTareaAnt'] = descrTarea
          argsPl['programacion'] = addColeccProg 
          argsPl['tipoAct'] = 'EditarProgramacion'
          creaColecc.push(argsPl)

          argsPl = {}
          addColeccProg = []
          
          if(i===listDocum.length-1){
            let updColeccPl = [], updColeccPl1 = []
            for(let iii=0; iii<creaColecc.length; iii++){
              updColeccPl.push(creaColecc[iii])
            }
            
            updColeccPl1.push({planta: updColeccPl})

            let numDocCRUD = 0
            let totDocCRUD = 1
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editPlantaEstructura)
            }
            argsCrud[numDocCRUD] = updColeccPl1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaEstructura

            this.updColecc(crudColecc, argsCrud, totDocCRUD)
          } 
  //FIN UPD
        }
        if(errors.length>0){
          this.setState({errors})
        }else{

          
          this.setState({listDocum: []})
        }
      
        document.body.style.cursor = 'default'

        if(errors.length===0){
          alert("!! Carga exitosa !!")
        }
      }        
    }     
    // console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  // async componentDidUpdate(prevProps){

  // }

  render(){ 
    const {listDocum, checked, permiteUpdate, confirmaAct, open, errors} = this.state;
    let mensaje = "PROCESAR ARCHIVO"
    let imgIcon = "images/archivo_32.png"

    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let tit1 = "ACTUALIZAR programación"
    let tit2 = "Procesar archivo de programación - ACTUALIZAR"
    if(this.props.tipoCargue==="Upd"){
      return(
        <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              {tit1}
          </button>
          <div>
            <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
              <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum):()=>{}}>
                <div>
                  <div className="ui one column stackable grid">
                      <div className="row container">
                          <div className="column" style={{width: '100%'}}>
                            <h1 style={{color: '#000000'}}>{tit2}</h1>
                          </div>
                      </div>
                  </div>
                  <hr></hr>
                  <hr></hr>
                  <br/>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={{color: '#000000', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                          Seleccionar archivo CSV...&nbsp;&nbsp;
                        </label>

                        <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                        {/* <output id="out" style={estilos1}>
                            file contents will appear here
                        </output> */}
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <p style={{color: '#000000', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                            <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                    name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                            &nbsp;&nbsp;Tiene encabezados en la primera fila
                          </p>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <hr></hr>
                  <hr></hr>
                  <p style={{color: '#000000', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Total documentos:&nbsp;
                    {listDocum.length}
                  </p>

                  <div className="ui one column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '100%'}}>
                        <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                      </div>
                    </div>
                  </div>
                  <hr></hr>

                  {
                      errors.length?<Message negative header="Los siguientes errores:"
                      list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                  }
                  <div style={{height: '30em', overflow: 'auto'}}>
                    <table id="tablaDocum" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                        <tr className=''>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Consecutivo</th>  
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aplicación/Espesante</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de Lubricante</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant Total</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cantidad</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Puntos a Lub</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Minutos ejec.</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Método de Lub</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tarea de Lub</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Modo ejec. tarea</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Requiere SISO</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Frecuencia</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Frecuencia Predictiva</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha próxima</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Procedimiento</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cod Advertencia tarea</th>
                          <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Activo para LCM</th>
                        </tr>
                      </thead>
                      <ListaDocum list={listDocum} tipoCargue={this.props.tipoCargue}/>
                    </table>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default compose(
  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),
  graphql(queries.query.allMetodo, {name:'allMetodo'}),
  graphql(queries.query.allTarea, {name:'allTarea'}),
  graphql(queries.query.allGrado, {name:'allGrado'}),
  graphql(queries.query.allProcEjec, {name:'allProcEjec'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.query.allInfoTarea, {name:'allInfoTarea'}),

  graphql(queries.mutation.createPlantaMany, {name:'createPlantaMany'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),
  
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(CargProg2)
